import isNumber from "lodash/isNumber";

export const avatarSize = (size) => {
    if (size == null)
        return 40;
    
    if (isNumber(size))
        return size;

    switch (size) {
        case '2xs':
            return 20;
        case 'xs':
            return 30;
        case 'sm':
            return 40;
        case 'md':
            return 50;
        case 'lg':
            return 80;
        case 'xl':
            return 100;
        case '2xl':
            return 120;
        default:
            return 40;
    }

};